<template>
  <section class="loadingError">
    <span class="adorasmile" data-anim="text">
      <span>
        :\
      </span>
    </span>
    <h3 data-anim="text">
      <span>Owopss! Something went wrong loading the page.</span>
    </h3>
    <p data-anim="text">
      <span>Blow on the cartridge and <b class="reload" @click="reload">reload</b>, it always works.</span>
    </p>
  </section>
</template>

<script>
import router from '@/router';

export default {
  name: 'LoadingError',
  methods: {
    reload: () => {
      router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';


.loadingError {
  position: absolute;
  display: inline-block;
  width: 100%;
  top: 50%;
  left: 20%;

  font-size: 1rem;

  transform: translateY(-50%);

  span,
  h3,
  .adorasmile {
    position: relative;
    display: block;

    b {
      color: #1217ff;
      cursor: pointer;
    }
  }

  .adorasmile {
    font-size: 8rem;
    color: transparent;
    -webkit-text-stroke: 2px $color-blue;
  }

  h3 {
    font-weight: 500;
    color: $color-light;
  }

  p {
    font-weight: normal;
    color: $color-dark-gray;
    max-width: 420px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/LoadingError.vue